import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import {
  Analytics,
  Dthc,
  GlobalNotifications,
  Intent
} from '../../Modules';
import ListTitleInput from './ListTitleInput';
import styles from './Pipelines.scss';

export default class PipelineListTitle extends React.Component {

  static propTypes = {
    list: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.updateListTitle = this.updateListTitle.bind(this);
  }

  updateListTitle(props) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update title',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      Analytics.trackEvent('updated-plist-title');
      GlobalNotifications.show({
        message: 'Successfully updated title',
        intent: Intent.SUCCESS
      });
    };

    const { id, title } = props;

    if (this.props.list.title !== title) {
      const mutation = graphql`
        mutation ListTitle_UpdatePlistMutation(
          $input: UpdatePlistInput!
        ) {
          updatePlist(input: $input) {
            plist {
              id
              title
            }
          }
        }
      `;

      const optimisticResponse = {
        updatePlist: { plist: { id, title } }
      };
      const environment = this.props.relay.environment;

      commitMutation(environment, {
        mutation,
        variables: {
          input: {
            id,
            title
          }
        },
        optimisticResponse,
        onCompleted,
        onError
      });
    }
  }

  render() {
    const { list } = this.props;
    return (
      <Dthc
        desktop={ListTitleInput}
        mobile={ListTitleInput}
        placeholder='(Untitled)'
        title={list.title}
        listId={list.id}
        commitUpdate={this.updateListTitle}
        handleClickOutside
        iconStyle={{ top: 0 }}
      >
        <h3 className={styles.listTitle}>{list.title}</h3>
      </Dthc>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/ListTitle.js